<template>
  <v-card>
    <v-card-title>
      {{ $t('REPORTS.MEDICALL') }}
    </v-card-title>

    <v-container grid-list-md text-md-right fluid fill-height>
      <v-spacer></v-spacer>
      <v-btn @click="getMedicalFile">
        {{ $t('BUTTON.EXPORT') }}
      </v-btn>
    </v-container>
  </v-card>
</template>

<script>
import downloadFile from '@/modules/_global/mixins/download-file';
import moment from 'moment';
import { mapActions } from 'vuex';

export default {
  name: 'MedicalFile',

  mixins: [downloadFile],

  data: () => ({
    datetimeNow: ''
  }),

  created() {
    this.datetimeNow = moment().format('YYYY-MM-DD');
  },

  methods: {
    ...mapActions('report', ['retrieveMedicall']),

    getMedicalFile() {
      return this.retrieveMedicall()
        .then(response => {
          let rootName = this.$t('REPORTS.MEDICALL');

          this.downloadFile(
            response,
            `${rootName}${this.datetimeNow}`
          );
        })
        .catch(error => {
          this.$emit('error', error);
        });
    }
  }
};
</script>
